import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { asyncScheduler, BehaviorSubject, fromEvent, merge, Observable, Subject } from 'rxjs';
import { filter, throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  click$: Observable<Event>;
  pointerEvent = new Subject<Event>();
  pointerEvent$ = this.pointerEvent.asObservable();
  pageVisible$ = new BehaviorSubject<boolean>(true);
  httpRequestCalled$ = new Subject();

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.click$ = fromEvent(this.document, 'click');

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.pageVisible$.next(true);
      } else {
        this.pageVisible$.next(false);
      }
    });

    document.addEventListener('mousedown', (event: Event) => {
      this.pointerEvent.next(event);
    });
    document.addEventListener('touchstart', (event: Event) => {
      this.pointerEvent.next(event);
    });
  }

  /**
   * Returns observable that emits event when ether app got visible (browser reopened, tab bgought to front)
   * or http call happened after passed interval in seconds
   */
  getActivityStream(interval: number) {
    return merge(
      this.pageVisible$.pipe(filter(v => !!v)),
      merge(this.httpRequestCalled$, this.click$).pipe(
        throttleTime(interval * 1000, asyncScheduler, { leading: true, trailing: true })
      )
    ).pipe(
      throttleTime(5000, asyncScheduler, { leading: true })
    )
  }
}
